import { FC } from 'react'
import clsx from 'clsx'
import { Link, useLocation } from 'react-router-dom'
// import {useLocation} from 'react-router'
import { checkIsActive, WithChildren } from '../../../../helpers'
import { DynamicIcon } from '../../../../../components/DynamicIcon'
import { useLayout } from '../../../core'

type Props = {
  to: string
  title: string
  icon?: string
  fontIcon?: string
  hasBullet?: boolean
  dataTour?: string
}

const SidebarMenuItem: FC<Props & WithChildren> = ({
  children,
  to,
  title,
  icon,
  fontIcon,
  hasBullet = false,
  dataTour,
}) => {
  const { pathname } = useLocation()
  const isActive = checkIsActive(pathname, to)
  const { config } = useLayout()
  const { app } = config

  return (
    <div className='menu-item'>
      <Link className={clsx('menu-link without-sub', { active: isActive })} to={to} data-tour={dataTour}>
        {hasBullet && (
          <span className='menu-bullet'>
            <span className='bullet bullet-dot'></span>
          </span>
        )}
        {icon && app?.sidebar?.default?.menu?.iconType === 'svg' && (
          <span className='menu-icon' style={{ transitionDelay: "0.2s" }}>
            {' '}
            <DynamicIcon name={icon} size={24} />
          </span>
        )}
        <span className='menu-title' style={{ transitionDelay: "0.2s" }}>{title}</span>
      </Link>
      {children}
    </div>
  )
}

export { SidebarMenuItem }
